import React from "react";
import "@/App.css";
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Applications } from './components/Applications';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './i18n';

function App() {
  // Set dark mode permanently
  React.useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <LanguageProvider>
      <div className="App min-h-screen dark">
        <Header />
        <main>
          <Hero />
          <About />
          <Services />
          <Process />
          <Applications />
          <Contact />
        </main>
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
